// extracted by mini-css-extract-plugin
export var button = "_kv-0";
export var donut = "_kv-1";
export var donutFill = "_kv-3";
export var donutTrack = "_kv-2";